import React from 'react';
import PropTypes from 'prop-types';

import { ChevronDownIcon } from '@mssgme/icons';
import { TextButton } from '@mssgme/ui';

import styles from './ToggleButton.scss';

ToggleButton.propTypes = {
    isPressed: PropTypes.bool,
    onToggle: PropTypes.func,
    children: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
};

ToggleButton.defaultProps = {
    isPressed: false,
};

export default function ToggleButton({ isPressed, children, onToggle }) {
    return (
        <TextButton aria-pressed={isPressed} className={styles.root} onClick={onToggle}>
            <span className={styles.label}>
                {typeof children === 'function' ? children({ isPressed, onToggle }) : children}
            </span>
            <ChevronDownIcon size={14} className={styles.arrow} />
        </TextButton>
    );
}
